import { relations } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../../auth'
import { Book } from '../../content'
import { ReadingSession } from './reading-session'

// =============================================================================
// PAGE READING ACTIVITY - Event log (source of truth, append-only)
// =============================================================================

export const PageReadingActivity = pgTable(
  'page_reading_activity',
  {
    id: uuid().primaryKey().defaultRandom(),
    readingSessionId: uuid()
      .references(() => ReadingSession.id, { onDelete: 'cascade' })
      .notNull(),
    userId: text().references(() => user.id, { onDelete: 'set null' }),
    bookId: uuid()
      .references(() => Book.id, { onDelete: 'cascade' })
      .notNull(),
    pageNumber: integer().notNull(),
    startedAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    endedAt: timestamp({ mode: 'date', withTimezone: true }),
    durationSeconds: integer(),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),

    // LEGACY
    legacyReadCountId: integer(),
  },
  (t) => [
    index('idx_pra_user_book').on(t.userId, t.bookId),
    index('idx_pra_session').on(t.readingSessionId),
    index('idx_pra_created').on(t.createdAt),
  ],
)

export const pageReadingActivityRelations = relations(PageReadingActivity, ({ one }) => ({
  readingSession: one(ReadingSession, {
    fields: [PageReadingActivity.readingSessionId],
    references: [ReadingSession.id],
  }),

  user: one(user, {
    fields: [PageReadingActivity.userId],
    references: [user.id],
  }),

  book: one(Book, {
    fields: [PageReadingActivity.bookId],
    references: [Book.id],
  }),
}))

export const InsertPageReadingActivitySchema = createInsertSchema(PageReadingActivity).omit({
  id: true,
  createdAt: true,
})
export const SelectPageReadingActivitySchema = createSelectSchema(PageReadingActivity)

export type InsertPageReadingActivity = typeof PageReadingActivity.$inferInsert
export type SelectPageReadingActivity = typeof PageReadingActivity.$inferSelect
